module.exports = __webpack_public_path__ + "static/media/addProduct.cbc1b76b.svg";